import { render, staticRenderFns } from "./full-container.vue?vue&type=template&id=61549c50&"
import script from "./full-container.vue?vue&type=script&lang=js&"
export * from "./full-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports